"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("./constants");

/**
 * Gets environment tier (E0, E1, E2, E3) based on given hostname.
 * @returns {string}
 */
var getEnvFromHost = function getEnvFromHost(hostname) {
  /* eslint-disable sort-keys */
  var environments = {
    localhost: _constants.LOCAL,
    "acquisition-dev.americanexpress.com": _constants.DEV,
    "acquisition-1-dev.americanexpress.com": _constants.DEV,
    "acquisition-2-dev.americanexpress.com": _constants.DEV,
    "acquisition-3-dev.americanexpress.com": _constants.DEV,
    "acquisition-4-dev.americanexpress.com": _constants.DEV,
    "acquisition-6-dev.americanexpress.com": _constants.DEV,
    "acquisition-green-qa.americanexpress.com": _constants.QA,
    "acquisition-1-green-qa.americanexpress.com": _constants.QA,
    "acquisition-2-green-qa.americanexpress.com": _constants.QA,
    "acquisition-3-green-qa.americanexpress.com": _constants.QA,
    "acquisition-4-green-qa.americanexpress.com": _constants.QA,
    "acquisition-qa.americanexpress.com": _constants.QA,
    "acquisition-1-qa.americanexpress.com": _constants.QA,
    "acquisition-2-qa.americanexpress.com": _constants.QA,
    "acquisition-3-qa.americanexpress.com": _constants.QA,
    "acquisition-4-qa.americanexpress.com": _constants.QA,
    "acquisition-6-qa.americanexpress.com": _constants.QA,
    "gcsfe-qa.americanexpress.com": _constants.QA,
    "gcsfe1-qa.americanexpress.com": _constants.QA,
    "gcsfe2-qa.americanexpress.com": _constants.QA,
    "gcsfe3-qa.americanexpress.com": _constants.QA,
    "gcsfe4-qa.americanexpress.com": _constants.QA,
    "gcsfe5-qa.americanexpress.com": _constants.QA,
    "qwww.americanexpress.com": _constants.QA,
    "acquisition2.americanexpress.com": _constants.PROD,
    "www.americanexpress.com": _constants.PROD
  };
  /* eslint-enable sort-keys */

  return environments[hostname] || _constants.PROD;
};

var _default = getEnvFromHost;
exports["default"] = _default;